/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvitationValidation
 */
export interface InvitationValidation {
    /**
     * 
     * @type {string}
     * @memberof InvitationValidation
     */
    referral_id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvitationValidation
     */
    permissions: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof InvitationValidation
     */
    expires_at: Date;
}

/**
 * Check if a given object implements the InvitationValidation interface.
 */
export function instanceOfInvitationValidation(value: object): value is InvitationValidation {
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    if (!('expires_at' in value) || value['expires_at'] === undefined) return false;
    return true;
}

export function InvitationValidationFromJSON(json: any): InvitationValidation {
    return InvitationValidationFromJSONTyped(json, false);
}

export function InvitationValidationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationValidation {
    if (json == null) {
        return json;
    }
    return {
        
        'referral_id': json['referral_id'],
        'permissions': json['permissions'],
        'expires_at': (new Date(json['expires_at'])),
    };
}

export function InvitationValidationToJSON(json: any): InvitationValidation {
    return InvitationValidationToJSONTyped(json, false);
}

export function InvitationValidationToJSONTyped(value?: InvitationValidation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referral_id': value['referral_id'],
        'permissions': value['permissions'],
        'expires_at': ((value['expires_at']).toISOString()),
    };
}

